export {default as getTeacher } from "./getTeacher";
